import React, { useEffect, useState } from "react";
import Listing from "../Listing";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
    getAllRejectedListings,
} from "../utils";
import { useAuth } from "../../contexts/AuthContext";

export default function RejectedListings() {
    const auth = useAuth();
    const [loading, setLoading] = useState(true);

    const [listings, setListings] = useState([]);

    // Sample columns
    const columns = [
        { Header: "ID", accessor: "id" },
        { Header: "Name", accessor: "name" },
        { Header: "Price", accessor: "price" },
        { Header: "backgroundImage", accessor: "backgroundImage" },
        // ... more columns
    ];

    useEffect(() => {
        const fetchListings = async () => {
            try {
                const listings = await getAllRejectedListings();
                setListings(listings);
            } catch (error) {
                console.error("Error fetching listings:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchListings();
    }, []);

    const transformedData = listings
        ? listings.map((listing) => ({
            id: String(listing.id),
            name: listing.listingTitle,
            price: listing.boatStatus,
            backgroundImage: listing.featured_image,
            boatListed: listing.boatListed,
        }))
        : [];

    return (
        <>
            <div class="row">
                <div class="col">
                    <div class="page-description">
                        <Row>
                            <Col xs={6}>
                                <h1>Rejected Listings</h1>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="card calendar-container">
                        <div class="card-body">
                            {/* Render the Listing component only if there is data */}
                            {listings && listings.length > 0 ? (
                                <Listing data={transformedData} columns={columns} />
                            ) : (
                                <p>No rejected listings available</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
